/* eslint-disable */
/**
 * Dynamic Variant Switcher for Product Cards
 * Handles switching between product variants dynamically without page reload
 */
(function ProductVariantSwitcherBootstrap() {
  
  class ProductVariantSwitcher {
    constructor(productCard) {
      this.card = productCard;
      this.productId = productCard.dataset.productId;
      this.variantSwitches = productCard.querySelectorAll('.variant-switches__button');
      this.currentVariant = null;
      this.dynamicVariantsElement = this.card.querySelector('.product-card__dynamic-variants');
      
      this.init();
    }
    
    init() {
      if (!this.variantSwitches.length) return;
      
      // Add event listeners
      this.variantSwitches.forEach((button) => {
        button.addEventListener('click', (e) => this.handleVariantClick(e));
      });
      
      // Set initial active state
      this.setInitialActiveState();
    }
    
    setInitialActiveState() {
      // Find the main product variant and mark it as active
      const mainVariant = Array.from(this.variantSwitches).find((btn) => btn.dataset.isMain === 'true');
      
      // Check if there's a matching variant based on active filters
      const matchingVariant = this.findMatchingVariantFromFilters();
      
      if (matchingVariant) {
        // Replace 5th visible variant with matching one if needed
        const variantToActivate = this.replaceVariantIfNeeded(matchingVariant) || matchingVariant;
        
        this.setActiveVariant(variantToActivate);
        this.updateProductInfo(variantToActivate);
      } else if (mainVariant) {
        this.setActiveVariant(mainVariant);
        this.updateProductInfo(mainVariant);
      }
    }
    
    findMatchingVariantFromFilters() {
      // Get active filter labels from DOM
      const activeFilters = this.getActiveFilterLabels();
      if (activeFilters.length === 0) return null;
      
      // Find ALL variants that match filters (prioritize available ones)
      const matchingVariants = [];
      const unavailableVariants = [];
      
      Array.from(this.variantSwitches).forEach((button) => {
        try {
          // Decode HTML entities before parsing JSON
          const rawData = button.dataset.variantData;
          
          if (!rawData) {
            return;
          }
          
          const decodedData = this.decodeHtmlEntities(rawData);
          
          const variantData = JSON.parse(decodedData);
          const colorLabels = this.getColorLabels(button, variantData);
          
          const isMatch = colorLabels.length > 0 && colorLabels.some((label) => this.matchesAnyFilter(label, activeFilters));
          if (isMatch) {
            if (variantData.is_available) {
              matchingVariants.push(button);
            } else {
              unavailableVariants.push(button);
            }
          }
        } catch (error) {
          // ignore parse errors silently
        }
      });
      
      // Return first available matching variant, or first unavailable if no available ones
      if (matchingVariants.length > 0) return matchingVariants[0];
      if (unavailableVariants.length > 0) return unavailableVariants[0];
      return null;
    }
    
    replaceVariantIfNeeded(matchingVariant) {
      // Get all variant switches container
      const switchesList = this.card.querySelector('.variant-switches');
      if (!switchesList) return;
      
      // Check if matching variant is already visible (within first 5 items)
      const visibleItems = Array.from(switchesList.children).slice(0, 5);
      const isAlreadyVisible = visibleItems.some((item) => {
        const itemButton = item.querySelector('.variant-switches__button');
        return itemButton && itemButton.dataset.variantData === matchingVariant.dataset.variantData;
      });
      
      if (isAlreadyVisible) return matchingVariant;
      
      // Replace the 5th item (index 4) with matching variant
      if (visibleItems.length >= 5) {
        const itemToReplace = visibleItems[4]; // 5th item (0-indexed)
        
        // Get variant data to create new HTML element
        const variantData = matchingVariant.dataset.variantData;
        const variantId = matchingVariant.dataset.variantId;
        const productId = matchingVariant.dataset.productId;
        const isMain = matchingVariant.dataset.isMain;
        const isAvailable = matchingVariant.dataset.isAvailable;
        const fabricLabel = matchingVariant.title;
        
        // Create new button element
        const newButton = document.createElement('button');
        newButton.type = 'button';
        newButton.className = 'variant-switches__button';
        newButton.dataset.variantId = variantId;
        newButton.dataset.productId = productId;
        newButton.dataset.variantData = variantData;
        newButton.dataset.isMain = isMain;
        newButton.dataset.isAvailable = isAvailable;
        newButton.setAttribute('aria-label', `Wybierz wariant ${fabricLabel}`);
        newButton.title = fabricLabel;
        newButton.innerHTML = matchingVariant.innerHTML;
        
        // Create new list item
        const newItem = document.createElement('li');
        newItem.className = 'variant-switches__item';
        newItem.appendChild(newButton);
        
        // Replace the 5th item
        itemToReplace.parentNode.replaceChild(newItem, itemToReplace);
        
        // Bind click handler to the newly inserted button and return it
        newButton.addEventListener('click', (e) => this.handleVariantClick(e));
        
        // Update this.variantSwitches to include the new button
        this.variantSwitches = this.card.querySelectorAll('.variant-switches__button');
        
        return newButton; 
      }
      
      return matchingVariant;
    }
    
    getColorLabels(button, variantData) {
      const datasetColor = button.dataset.color || '';
      const labelsFromDataset = datasetColor
        .split(',')
        .map((label) => label.trim())
        .filter((label) => label.length > 0);
      
      if (labelsFromDataset.length > 0) {
        return labelsFromDataset;
      }
      
      const fallbackLabel = variantData.fabric_swatch?.label;
      if (fallbackLabel) {
        return [fallbackLabel];
      }
      
      return [];
    }
    
    getActiveFilterLabels() {
      const activeFiltersContainer = document.getElementById('FacetFiltersActive');
      if (!activeFiltersContainer) return [];
      
      const filterLabels = [];
      const filterElements = activeFiltersContainer.querySelectorAll('.facet-remove .facet-title');
      
      filterElements.forEach((element) => {
        // Get text content, removing any swatch elements
        const textContent = element.textContent.trim();
        if (textContent) {
          filterLabels.push(textContent);
        }
      });
      
      return filterLabels;
    }
    
    normalizeText(text) {
      if (!text) return '';
      const normalized = text
        .toString()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // remove diacritics
        .replace(/\s+/g, ' ') // collapse spaces
        .trim();
      return normalized;
    }

    // Mirrors Shopify's `| handle` Liquid filter (lowercase, diacritics stripped,
    // any run of non-alphanumeric chars collapsed to a single hyphen, trimmed).
    // snippets/product-badges.liquid matches tags against product_new_tags/etc.
    // via `| handle` server-side - tag-list comparisons here must use the same
    // normalization, or a tag that matches on the server can mismatch on the
    // client (badge renders from SSR, then vanishes once this JS re-renders it).
    toHandle(text) {
      if (!text) return '';
      return text
        .toString()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // remove diacritics
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    // Presentational only: turns a raw Akeneo tag (e.g. "bez_vat") into a
    // human-readable label ("Bez Vat"). Matching against tag lists must keep
    // using the raw value - only call this on the text shown to the user.
    formatBadgeLabel(label) {
      if (!label) return label;
      return label
        .toString()
        .replace(/[_-]+/g, ' ')
        .split(' ')
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    }

    matchesAnyFilter(variantLabel, activeFilters) {
      if (!variantLabel) return false;
      
      const normalizedVariantLabel = this.normalizeText(variantLabel);
      
      const matched = activeFilters.some((filterLabel) => {
        const normalizedFilterLabel = this.normalizeText(filterLabel);
        
        // Exact match
        if (normalizedVariantLabel === normalizedFilterLabel) {
          return true;
        }
        
        // Partial match (e.g., "Zielony" matches "Zielony (oliwkowy)")
        if (normalizedVariantLabel.includes(normalizedFilterLabel) || 
            normalizedFilterLabel.includes(normalizedVariantLabel)) {
          return true;
        }
        
        return false;
      });
      return matched;
    }
    
    handleVariantClick(event) {
      event.preventDefault();
      const button = event.currentTarget;
      
      // Allow clicking on all variants, even unavailable ones
      this.setActiveVariant(button);
      this.updateProductInfo(button);
    }
    
    setActiveVariant(activeButton) {
      // Remove active class from all buttons
      this.variantSwitches.forEach((btn) => {
        btn.classList.remove('variant-switches__button--active');
      });
      
      // Add active class to clicked button
      activeButton.classList.add('variant-switches__button--active');
    }
    
    updateProductInfo(button) {
      try {
        // Decode HTML entities before parsing JSON
        const rawData = button.dataset.variantData;
        
        if (!rawData) { return; }
        
        const decodedData = this.decodeHtmlEntities(rawData);
        
        const variantData = JSON.parse(decodedData);
        this.currentVariant = variantData;
        
        // Update all product information
        this.updateImages(variantData);
        this.updateTitle(variantData);
        this.updateProducer(variantData);
        this.updatePrice(variantData);
        this.updateBadges(variantData);
        this.updateFeatures(variantData);
        this.updateUrl(variantData);
        this.updateAddToCartButton(variantData);
        this.updateOmnibusPrice(variantData);
        this.updateInstallments(variantData);
        
      } catch (error) { /* no-op */ }
    }
    
    /**
     * Resize Shopify CDN image URL to 800x800px
     * @param {string} imageUrl - Original image URL
     * @returns {string} - Resized image URL
     */
    resizeImageUrl(imageUrl) {
      if (!imageUrl || typeof imageUrl !== 'string') return imageUrl;
      
      try {
        const url = new URL(imageUrl);
        
        // Set width and height to 800px
        url.searchParams.set('width', '800');
        url.searchParams.set('height', '800');
        
        return url.toString();
      } catch (e) {
        // If URL parsing fails, try string replacement
        // Remove existing width/height params and add new ones
        let modifiedUrl = imageUrl.replace(/[?&]width=\d+/gi, '');
        modifiedUrl = modifiedUrl.replace(/[?&]height=\d+/gi, '');
        
        // Add new dimensions
        const separator = modifiedUrl.includes('?') ? '&' : '?';
        return `${modifiedUrl}${separator}width=800&height=800`;
      }
    }

    updateImages(variantData) {
      // Helper function to update image with preloading
      const updateImage = (container, imageUrl, title, isMain = false) => {
        if (!container || !imageUrl) return;
        
        // Resize image URL to 800x800px
        const resizedImageUrl = this.resizeImageUrl(imageUrl);
        
        // Store original aspect ratio and classes
        const originalAspectRatio = container.style.getPropertyValue('--aspect-ratio');
        // Remove loading/loaded classes from original classes to avoid conflicts
        const originalClasses = container.className
          .split(' ')
          .filter(cls => cls !== 'loading' && cls !== 'loaded')
          .join(' ');
        
        // Add loading class to hide image during load
        container.classList.add('loading');
        container.classList.remove('loaded');
        
        // Preload image using link rel="preload" for main image (faster loading)
        if (isMain) {
          const preloadLink = document.createElement('link');
          preloadLink.rel = 'preload';
          preloadLink.as = 'image';
          preloadLink.href = resizedImageUrl;
          preloadLink.fetchPriority = 'high';
          document.head.appendChild(preloadLink);
        }
        
        // Preload image before showing it
        const imgPreload = new Image();
        
        imgPreload.onload = () => {
          // Remove preload link if it was added
          if (isMain) {
            const preloadLink = document.querySelector(`link[href="${resizedImageUrl}"]`);
            if (preloadLink) {
              preloadLink.remove();
            }
          }
          
          // Create new image element
          const newImage = document.createElement('img');
          newImage.src = resizedImageUrl;
          newImage.alt = title || '';
          newImage.className = 'motion-reduce';
          // Use eager loading for main image (visible immediately), lazy for hover image
          newImage.loading = isMain ? 'eager' : 'lazy';
          if (isMain) {
            newImage.fetchPriority = 'high';
          }
          
          // Replace container content
          // eslint-disable-next-line no-param-reassign
          container.innerHTML = '';
          // eslint-disable-next-line no-param-reassign
          container.appendChild(newImage);
          
          // Restore original classes and aspect ratio
          // eslint-disable-next-line no-param-reassign
          container.className = originalClasses;
          if (originalAspectRatio) {
            // eslint-disable-next-line no-param-reassign
            container.style.setProperty('--aspect-ratio', originalAspectRatio);
          }
          
          // Remove loading class and add loaded class to show the image
          // Do this after restoring original classes to ensure proper state
          container.classList.remove('loading');
          container.classList.add('loaded');
        };
        
        imgPreload.onerror = () => {
          // Remove preload link on error
          if (isMain) {
            const preloadLink = document.querySelector(`link[href="${resizedImageUrl}"]`);
            if (preloadLink) {
              preloadLink.remove();
            }
          }
          
          // Remove loading class even on error
          container.classList.remove('loading');
        };
        
        // Start loading the image immediately
        imgPreload.src = resizedImageUrl;
      };
      
      // Update main image (eager loading, high priority)
      const mainImageContainer = this.card.querySelector('.product-card__image--main');
      updateImage(mainImageContainer, variantData.image, variantData.title, true);
      
      // Update second (hover) image (lazy loading, low priority)
      const secondImageContainer = this.card.querySelector('.product-card__image--second');
      updateImage(secondImageContainer, variantData.image_hover, variantData.title, false);
    }
    
    updateTitle(variantData) {
      const titleLink = this.card.querySelector('.product-card__title .reversed-link__text');
      if (titleLink && variantData.title) {
        titleLink.textContent = variantData.title;
      }
    }
    
    updateProducer(variantData) {
      const producerElement = this.card.querySelector('.product-card__seria');
      if (producerElement && variantData.producer) {
        producerElement.textContent = variantData.producer;
      }
    }
    
    updatePrice(variantData) {
      // Convert prices to numbers for comparison
      const price = this.parsePrice(variantData.price);
      const compareAtPrice = this.parsePrice(variantData.compare_at_price);
      
      // Check if we have a sale (compare_at_price > price)
      const hasSale = compareAtPrice > 0 && compareAtPrice > price;
      
      // Update the main price container class to control visibility via CSS
      const priceContainer = this.card.querySelector('.f-price');
      if (priceContainer) {
        if (hasSale) {
          priceContainer.classList.add('f-price--on-sale');
        } else {
          priceContainer.classList.remove('f-price--on-sale');
        }
      }
      
      // Update regular price elements (but not the ones with crossed-out price)
      const regularPriceElements = this.card.querySelectorAll('.f-price-item--regular');
      regularPriceElements.forEach((element) => {
        // Skip elements that contain <s> tag (crossed-out price)
        if (!element.querySelector('s') && variantData.price) {
          element.textContent = this.formatPrice(variantData.price);
        }
      });
      
      // Update sale price elements
      const salePriceElements = this.card.querySelectorAll('.f-price-item--sale');
      salePriceElements.forEach((element) => {
        if (variantData.price) {
          element.textContent = this.formatPrice(variantData.price);
        }
      });
      
      // Update compare at price (strikethrough) - this is the crossed-out price
      // The structure is: <span class="f-price-item f-price-item--regular"><s>price</s></span>
      // Only show crossed-out price if compare_at_price > price
      if (hasSale) {
        const comparePriceElements = this.card.querySelectorAll('.f-price__sale .f-price-item--regular s');
        
        if (comparePriceElements.length === 0) {
          // If no crossed-out price elements exist, we need to create them
          this.createCrossedOutPrice(variantData);
        } else {
          comparePriceElements.forEach((element) => {
            element.textContent = this.formatPrice(variantData.compare_at_price);
          });
        }
      }
    }
    
    createCrossedOutPrice(variantData) {
      // Find the sale price section and add crossed-out price
      const saleSection = this.card.querySelector('.f-price__sale');
      if (saleSection && variantData.compare_at_price) {
        // Find the last regular price element in sale section
        const lastRegularPrice = saleSection.querySelector('.f-price-item--regular:last-child');
        if (lastRegularPrice) {
          // Wrap the content in <s> tag
          lastRegularPrice.innerHTML = `<s>${this.formatPrice(variantData.compare_at_price)}</s>`;
        }
      }
    }
    
    updateBadges(variantData) {
      const badgeContainer = this.card.querySelector('.product-card__badge');
      if (!badgeContainer) {
        return;
      }
      
      // Get tag lists from data attributes
      const dynamicVariants = this.card.querySelector('.product-card__dynamic-variants');
      const newTags = dynamicVariants.dataset.newTags ? dynamicVariants.dataset.newTags.split(',') : [];
      const hotTags = dynamicVariants.dataset.hotTags ? dynamicVariants.dataset.hotTags.split(',') : [];
      const comingTags = dynamicVariants.dataset.comingTags ? dynamicVariants.dataset.comingTags.split(',') : [];
      const selseyTags = dynamicVariants.dataset.selseyTags ? dynamicVariants.dataset.selseyTags.split(',') : [];
      
      // Get Odoo metafield values
      const odooNew = dynamicVariants?.dataset.odooNew;
      const odooBestseller = dynamicVariants?.dataset.odooBestseller;
      const odooExpressDelivery = dynamicVariants?.dataset.odooExpressDelivery;
      const variantExpressDelivery = (variantData.express_delivery || '').trim();
      
      // Get Odoo labels (translations)
      const odooNewLabel = dynamicVariants?.dataset.odooNewLabel || '';
      const odooBestsellerLabel = dynamicVariants?.dataset.odooBestsellerLabel || '';
      
      // Clear existing badges (sold out and sale badges are disabled)
      const existingBadges = badgeContainer.querySelectorAll('.f-badge'); 
      existingBadges.forEach(badge => badge.remove());
      
      // Track badges to avoid duplicates (type + text)
      const renderedBadges = new Set();

      // Track which Odoo badge types have been added from JSON to avoid duplicates
      const addedOdooTypes = new Set();
      
      // Function to get badge type and display text based on label (case-insensitive, with Polish character normalization)
      const getBadgeInfo = (label) => {
        if (!label) return { type: '', text: label };
        
        // Normalize label for comparison (case-insensitive, remove diacritics)
        const normalizedLabel = this.normalizeText(label);
        
        // Check against Odoo metafields FIRST (priority) - compare with both values and labels (normalized)
        // Use labels as indicator (they exist even if metafield values are empty)
        if (odooNewLabel && odooNewLabel !== '') {
          const normalizedOdooNew = odooNew ? this.normalizeText(odooNew) : '';
          const normalizedOdooNewLabel = this.normalizeText(odooNewLabel);
          if (normalizedLabel === normalizedOdooNew || normalizedLabel === normalizedOdooNewLabel) {
            return { type: 'odo-new', text: odooNewLabel };
          }
        }
        
        if (odooBestsellerLabel && odooBestsellerLabel !== '') {
          const normalizedOdooBestseller = odooBestseller ? this.normalizeText(odooBestseller) : '';
          const normalizedOdooBestsellerLabel = this.normalizeText(odooBestsellerLabel);
          if (normalizedLabel === normalizedOdooBestseller || normalizedLabel === normalizedOdooBestsellerLabel) {
            return { type: 'odo-bestseller', text: odooBestsellerLabel };
          }
        }
        
        if (variantExpressDelivery) {
          const normalizedVariantExpress = this.normalizeText(variantExpressDelivery);
          if (normalizedLabel === normalizedVariantExpress) {
            return { type: 'odo-express-delivery', text: variantExpressDelivery };
          }
        }
        
        if (odooExpressDelivery) {
          const normalizedOdooExpressDelivery = this.normalizeText(odooExpressDelivery);
          if (normalizedLabel === normalizedOdooExpressDelivery) {
            return { type: 'odo-express-delivery', text: odooExpressDelivery };
          }
        }
        
        // Check against tag lists using the same `| handle` normalization
        // product-badges.liquid uses server-side (not normalizeText) - see toHandle().
        const handleLabel = this.toHandle(label);
        const handleNewTags = newTags.map(tag => this.toHandle(tag));
        const handleHotTags = hotTags.map(tag => this.toHandle(tag));
        const handleComingTags = comingTags.map(tag => this.toHandle(tag));
        const handleSelseyTags = selseyTags.map(tag => this.toHandle(tag));

        // If badge matches newTags and odooNewLabel exists, use Odoo type and label
        if (handleNewTags.includes(handleLabel)) {
          if (odooNewLabel && odooNewLabel !== '') {
            return { type: 'odo-new', text: odooNewLabel };
          }
          return { type: 'new', text: this.formatBadgeLabel(label) };
        }

        if (handleHotTags.includes(handleLabel)) {
          // If badge matches hotTags and odooBestsellerLabel exists, use Odoo type and label
          if (odooBestsellerLabel && odooBestsellerLabel !== '') {
            return { type: 'odo-bestseller', text: odooBestsellerLabel };
          }
          return { type: 'hot', text: this.formatBadgeLabel(label) };
        }

        if (handleComingTags.includes(handleLabel)) return { type: 'coming', text: this.formatBadgeLabel(label) };
        if (handleSelseyTags.includes(handleLabel)) return { type: 'selsey', text: this.formatBadgeLabel(label) };
        
        // Fallback: if badge is "nowosc" or "bestseller" and Odoo labels exist, use Odoo types
        // This handles cases where badge doesn't match tags but should still use Odoo styling
        // Use labels as indicator (they exist even if metafield values are empty)
        if (normalizedLabel === 'nowosc') {
          if (odooNewLabel && odooNewLabel !== '') {
            return { type: 'odo-new', text: odooNewLabel };
          }
        }
        
        if (normalizedLabel === 'bestseller') {
          if (odooBestsellerLabel && odooBestsellerLabel !== '') {
            return { type: 'odo-bestseller', text: odooBestsellerLabel };
          }
        }
        
        // Default fallback - badge doesn't match any tags
        return { type: '', text: label };
      };
      
      // Helper function to create badge elements (guards against duplicates)
      const createBadge = (text, badgeType = '') => {
        const normalizedText = (text || '').trim();
        if (!normalizedText) return;

        const normalizedType = badgeType ? badgeType.trim() : 'default';
        const badgeKey = `${normalizedType}::${this.normalizeText(normalizedText)}`;
        if (renderedBadges.has(badgeKey)) {
          return;
        }

        const badgeElement = document.createElement('span');
        badgeElement.className = badgeType ? `f-badge f-badge--${badgeType}` : 'f-badge';
        badgeElement.textContent = normalizedText;
        badgeElement.setAttribute('aria-hidden', 'true');
        badgeContainer.appendChild(badgeElement);

        renderedBadges.add(badgeKey);
      };
      
      // Add badges from JSON
      if (variantData.badges && variantData.badges.length > 0) {
        variantData.badges.forEach((badge) => {
          // Handle both string and object formats
          const badgeLabel = typeof badge === 'string' ? badge : badge.label;
          if (!badgeLabel) {
            return;
          }
          const badgeInfo = getBadgeInfo(badgeLabel);
          const isOdooBadge = badgeInfo.type && badgeInfo.type.startsWith('odo-');

          if (!isOdooBadge) {
            // `| handle` here too, matching product-badges.liquid - see toHandle().
            const handleBadgeLabel = this.toHandle(badgeLabel);
            const isMappedInThemeSettings =
              newTags.some(t => this.toHandle(t) === handleBadgeLabel) ||
              hotTags.some(t => this.toHandle(t) === handleBadgeLabel) ||
              comingTags.some(t => this.toHandle(t) === handleBadgeLabel) ||
              selseyTags.some(t => this.toHandle(t) === handleBadgeLabel);
            if (!isMappedInThemeSettings) {
              return;
            }
          }

          createBadge(badgeInfo.text, badgeInfo.type);

          // Track Odoo badge types that were added from JSON
          if (isOdooBadge) {
            addedOdooTypes.add(badgeInfo.type);
          }
        });
      }
      
      if (
        variantExpressDelivery &&
        variantExpressDelivery !== '' &&
        variantExpressDelivery !== 'null' &&
        !addedOdooTypes.has('odo-express-delivery')
      ) {
        createBadge(variantExpressDelivery, 'odo-express-delivery');
        addedOdooTypes.add('odo-express-delivery');
      }

      // The variant JSON's own badges list isn't guaranteed to include the
      // Odoo badges for every variant, which was silently dropping
      // Bestseller/Nowość badges that the server had already rendered
      // (cleared above). Fall back to the product's own Odoo metafields,
      // mirroring the same condition used server-side in card-product.liquid
      // / product-badges.liquid.
      if (odooNew === 'news_30' && !addedOdooTypes.has('odo-new')) {
        createBadge(odooNewLabel, 'odo-new');
        addedOdooTypes.add('odo-new');
      }

      if (odooBestseller === 'true' && !addedOdooTypes.has('odo-bestseller')) {
        createBadge(odooBestsellerLabel, 'odo-bestseller');
        addedOdooTypes.add('odo-bestseller');
      }
    }
    
    updateFeatures(variantData) {
      // Update features if features container exists
      const featuresContainer = this.card.querySelector('.product-card__features');
      if (featuresContainer && variantData.features) {
        featuresContainer.innerHTML = '';
        variantData.features.forEach(feature => {
          const featureElement = document.createElement('div');
          featureElement.className = 'product-card__feature';
          featureElement.innerHTML = `<span class="product-card__feature-icon">✓</span> ${feature}`;
          featuresContainer.appendChild(featureElement);
        });
      }
    }
    
    updateUrl(variantData) {
      // Update product URL
      const productLinks = this.card.querySelectorAll('a[href*="/products/"]');
      productLinks.forEach((link) => {
        if (variantData.url) {
          // eslint-disable-next-line no-param-reassign
          link.href = variantData.url;
        }
      });
    }
    
    updateAddToCartButton(variantData) {
      // Update Add to Cart button based on availability
      const atcButtons = this.card.querySelectorAll('.product-card__atc, .product-card__list-atc, button[type="submit"]');
      atcButtons.forEach((button) => {
        const btnText = button.querySelector('.btn__text');
        if (!btnText) return;
        
        if (variantData.is_available) {
          // Available variant
          // eslint-disable-next-line no-param-reassign
          button.disabled = false;
          button.classList.remove('product-card__action-button--full');
          
          // Show add to cart icon and hide text
          const icon = button.querySelector('.product-card__atc-icon, .product-card__action-icon');
          const textElement = button.querySelector('.product-card__atc-text, .product-card__action-text');
          
          if (icon) {
            // eslint-disable-next-line no-param-reassign
            icon.style.display = 'inline-flex';
          }
          if (textElement) {
            // eslint-disable-next-line no-param-reassign
            textElement.style.display = 'none';
          }
          
          // Update hidden variant ID input
          const variantInput = this.card.querySelector('.product-variant-id');
          if (variantInput) {
            // eslint-disable-next-line no-param-reassign
            variantInput.value = variantData.variant_id;
            // eslint-disable-next-line no-param-reassign
            variantInput.disabled = false;
          }
        } else {
          // Unavailable variant
          // eslint-disable-next-line no-param-reassign
          button.disabled = true;
          button.classList.add('product-card__action-button--full');
          
          // Hide icon and show text
          const icon = button.querySelector('.product-card__atc-icon, .product-card__action-icon');
          let textElement = button.querySelector('.product-card__atc-text, .product-card__action-text');
          
          if (icon) {
            // eslint-disable-next-line no-param-reassign
            icon.style.display = 'none';
          }
          
          // Create text element if it doesn't exist
          if (!textElement) {
            textElement = document.createElement('span');
            textElement.className = 'product-card__atc-text product-card__action-text';
            btnText.appendChild(textElement);
          }
          
          // Get sold out text from translations
          const dynamicVariants = this.card.querySelector('.product-card__dynamic-variants');
          const soldOutText = dynamicVariants?.dataset.soldOutText || 'Wyprzedane';
          // eslint-disable-next-line no-param-reassign
          textElement.textContent = soldOutText;
          // eslint-disable-next-line no-param-reassign
          textElement.style.display = 'inline';
          
          // Update hidden variant ID input
          const variantInput = this.card.querySelector('.product-variant-id');
          if (variantInput) {
            // eslint-disable-next-line no-param-reassign
            variantInput.value = variantData.variant_id;
            // eslint-disable-next-line no-param-reassign
            variantInput.disabled = true;
          }
        }
      });
    }
    
    updateOmnibusPrice(variantData) {
      const omnibusContainer = this.card.querySelector('.product__omnibus');
      if (!omnibusContainer) return;
      
      // Get omnibus text from data attribute
      const dynamicVariants = this.card.querySelector('.product-card__dynamic-variants');
      const omnibusText = dynamicVariants?.dataset.omnibusText || 'Najniższa cena z 30 dni przed obniżką';
      
      // Convert and check if lowest_price_30_days exists and is greater than 0
      const lowestPrice = this.parsePrice(variantData.lowest_price_30_days);
      if (lowestPrice > 0) {
        // Show omnibus price with formatting
        const formattedPrice = this.formatPrice(lowestPrice);
        // eslint-disable-next-line no-param-reassign
        omnibusContainer.innerHTML = `${omnibusText} ${formattedPrice}`;
        // eslint-disable-next-line no-param-reassign
        omnibusContainer.style.display = 'block';
      } else {
        // Hide omnibus price if no data
        // eslint-disable-next-line no-param-reassign
        omnibusContainer.style.display = 'none';
      }
    }
    
    updateInstallments(variantData) {
      const installmentsContainer = this.card.querySelector('.buy-in-installments__price');
      if (!installmentsContainer) return;
      
      // Get best_count from data attribute
      const bestCount = parseInt(installmentsContainer.dataset.bestCount, 10);
      if (!bestCount) return;
      
      // Convert price to number and calculate new installment price
      const price = this.parsePrice(variantData.price);
      const installmentPrice = price / bestCount;
      const formattedInstallmentPrice = this.formatPrice(installmentPrice);
      
      // Get translations from data attributes
      const dynamicVariants = this.card.querySelector('.product-card__dynamic-variants');
      // const installmentsFromText = dynamicVariants?.dataset.installmentsFrom || 'od';
      // const ratText = dynamicVariants?.dataset.rat || 'rat';
      
      // Update installment price (keep the structure)
      const strongElements = installmentsContainer.querySelectorAll('strong');
      if (strongElements.length >= 2) {
        // Update the price (second strong element)
        strongElements[1].textContent = formattedInstallmentPrice;
      }
    }
    
    /**
     * Convert price to number (handles both string and number formats)
     * @param {string|number} price - Price value
     * @returns {number} - Price as number
     */
    parsePrice(price) {
      if (typeof price === 'number') return price;
      if (typeof price === 'string') {
        return parseFloat(price.replace(/\s/g, '').replace(',', '.') || '0');
      }
      return 0;
    }

    formatPrice(price) {
      const numericPrice = this.parsePrice(price);
    
      const formatted = new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(numericPrice);
    
      return `${formatted} €`;
    }
    
    decodeHtmlEntities(text) {
      const textarea = document.createElement('textarea');
      textarea.innerHTML = text;
      return textarea.value;
    }
  }
  
  // Initialize variant switchers for all product cards with dynamic variants
  function initializeVariantSwitchers() {
    const productCards = document.querySelectorAll('.product-card__dynamic-variants');
    productCards.forEach((card) => {
      // Check if switcher is already initialized
      if (!card.closest('.product-card').dataset.variantSwitcherInitialized) {
        new ProductVariantSwitcher(card.closest('.product-card'));
        card.closest('.product-card').dataset.variantSwitcherInitialized = 'true';
      }
    });
  }

  // Initialize on DOM ready
  document.addEventListener('DOMContentLoaded', initializeVariantSwitchers);

  // Re-initialize after facet updates (when filters are applied)
  /* global FoxTheme */
  if (typeof FoxTheme !== 'undefined' && FoxTheme.pubsub) {
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate, () => {
      // Small delay to ensure DOM is updated
      setTimeout(initializeVariantSwitchers, 100);
    });
  }
  
  // Export for potential external use
  window.ProductVariantSwitcher = ProductVariantSwitcher;
})();
